export const PROGRAMME = {
  MARKETS: ["Leaving Cert", "Junior Cert", "Primary"],
  ERRORS: {
    loading: "Error loading programme"
  }
};
